(() => {
  if (typeof window.customElements.get('product-gallery') !== 'undefined') { return }

  window.customElements.define('product-gallery', class ProductGallery extends HTMLElement { // eslint-disable-line
    constructor() {
      super()
      this.swiperEls = this.querySelectorAll('[data-swiper]')
      this.swipers = this.init()
    }

    init() {
      if (!this.swiperEls) return null

      const swipers = [...this.swiperEls].map((swiperEl) => {
        const swiper = new Swiper(swiperEl, {
          loop: false,
          slidesPerView: 'auto',
          threshold: 10,
          noSwiping: false,
          draggable: true,
          breakpoints: {
            990: {
              enabled: false
            }
          },
          on: {
            update: (swiper) => {
              console.log(swiper)
            }
          }
        })

        return swiper
      })

      return swipers
    }

    update() {
      if (!this.swipers || !this.swipers.length) return
      this.swipers.forEach(swiper => {
        swiper.update()
      })
    }
  })
})()
